import { z } from 'zod/v4';
export var Stage;
(function (Stage) {
    Stage["DEVELOP"] = "develop";
    Stage["PREPROD"] = "preprod";
    Stage["PROD"] = "prod";
})(Stage || (Stage = {}));
export const StageSchema = z.enum(Object.values(Stage));
//# sourceMappingURL=stage.js.map